import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component, computed,
  inject,
  input,
  OnChanges
} from '@angular/core';
import { NoteChangePrice } from "../../types/note-change-price.types";
import { GetSelectDataParams } from "../../../../../../../../core/types/records-table.types";
import { NoteChangePriceService } from "../../services/note-change-price.service";
import { noteChangePriceProduct } from "../../configs/note-change-price-config";

@Component({
  selector: 'app-note-change-price-header',
  standalone: true,
  imports: [],
  templateUrl: './note-change-price-header.component.html',
  styleUrl: './note-change-price-header.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class NoteChangePriceHeaderComponent implements OnChanges {
  noteChangePriceData = input.required<NoteChangePrice>();

  private noteChangePriceService: NoteChangePriceService = inject(NoteChangePriceService);
  private cd: ChangeDetectorRef = inject(ChangeDetectorRef);

  public productName: string = '';
  public productId = computed(() => this.noteChangePriceData().productId);

  public async ngOnChanges(): Promise<void> {
    this.productId() && await this.getProductSelectData();
  }

  private async getProductSelectData() {
    const getSelectDataParams: GetSelectDataParams = {
      propertyLazySelect: noteChangePriceProduct,
      id: this.productId()
    };

    const selectData = await this.noteChangePriceService.getProductSelectData(getSelectDataParams)
      .catch(() => []);
    this.productName = selectData.at(0)?.value || '';
    this.cd.markForCheck();
  }
}
